import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntroTopRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 996,
	height: 580,
	viewBox: "0 0 996 580",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 -1242.75H1810.56V579.5C402.67 359.12 220.62 173.17 0 -1242.75Z",
		fill: "#303651"
	})
});
export default SvgIntroTopRight;
